import { render, staticRenderFns } from "./ProductFacilitatorCategory.vue?vue&type=template&id=192a2e3e&scoped=true"
import script from "./ProductFacilitatorCategory.vue?vue&type=script&lang=js"
export * from "./ProductFacilitatorCategory.vue?vue&type=script&lang=js"
import style0 from "./ProductFacilitatorCategory.vue?vue&type=style&index=0&id=192a2e3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "192a2e3e",
  null
  
)

export default component.exports